import { UNASSIGNED_ROUTE_ID } from "./sessionOps";

export type MapKeyMark = "both" | "routeStop" | "unassigned" | "start" | "end";

/** Use rendered markers so hidden routes, closed panels, and missing coordinates cannot leave stale keys. */
export function mapKeyMarks(
  markers: ReadonlyArray<{ routeId: string }>,
  endpoints: ReadonlyArray<{ kind: "both" | "start" | "end" }>,
): MapKeyMark[] {
  const marks = new Set<MapKeyMark>(endpoints.map((marker) => marker.kind));
  for (const marker of markers) {
    marks.add(
      marker.routeId === UNASSIGNED_ROUTE_ID ? "unassigned" : "routeStop",
    );
  }
  return (["both", "start", "end", "routeStop", "unassigned"] as const).filter(
    (mark) => marks.has(mark),
  );
}
